module.exports = __webpack_public_path__ + "static/media/overview6_1.f9e35f6f.png";